import React from 'react';
import AudioBookItem from '../../components/AudioBookItem/AudioBookItem';
import style from './CommercialsSection.module.css';
import mediaItems from '../../jsons/commercials.json'


const CommercialsSection = () => {

  return (
    <div className={style.CommercialsSectionContainer}>
      {mediaItems.map((item, index) => (
        <AudioBookItem
          key={index}
          type={item.type}
          audioImg={item.image}
          audio={item.source}
        />
      ))}
    </div>
  );
};

export default CommercialsSection;
